<template>
  <svg viewBox="0 0 512 512" v-on="$listeners">
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="48"
      d="M112 328l144-144l144 144"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'expand-up',
}
</script>
